<link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap" />
<link
  rel="stylesheet"
  href="https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap" />

<fol-header />

@if (currentTheming$ | async) {
  <div class="row strap">
    <div class="item primary background"></div>
  </div>
}

<router-outlet></router-outlet>
